<template>
  <td
    v-if="isAnalyzed(item.status) && result"
    style="width: 300px"
    :class="cefrStyleClass(cefrLevel)"
  >
    {{ cefrLevel }}
    ({{ result.score }})
  </td>
  <td v-else style="width: 300px">{{ getStatus() }}</td>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api";
import { cefrStyleClass } from "@/components/utils/commonUtils";
import { i18n } from "@/locales/i18n";
import type { CategoryWithDescription, CefrResults } from "@/resources/dialog";
import type { CampaignResults } from "@/resources/package";
import { determineCampaignStatus } from "@/utils";

type ScoreKey = keyof CefrResults;

export default defineComponent({
  name: "OverviewCouponColumn",

  props: {
    item: {
      type: Object as () => CampaignResults["rows"][0],
      required: true,
    },
    couponCode: {
      type: String,
      required: true,
    },
    tabIndex: {
      type: String,
      required: false,
    },
  },

  computed: {
    result(): CategoryWithDescription | undefined {
      const key = this.tabIndex as ScoreKey;
      return this.item.score?.[key];
    },
    cefrLevel(): string {
      return this.result?.cefrLevel || this.result?.label || "";
    },
  },

  methods: {
    cefrStyleClass,
    isAnalyzed(status: string) {
      return (
        determineCampaignStatus(status) ===
        i18n.t("campaignResult.status.analyzed")
      );
    },
    getStatus() {
      const status = determineCampaignStatus(this.item.status);
      if (
        this.item.canDo &&
        this.item.canDo !== "" &&
        status === i18n.t("campaignResult.status.completed")
      ) {
        return `${i18n.t("packageResults.canDo")} ${this.item.canDo}`;
      } else {
        return status;
      }
    },
  },
});
</script>
